<button *ngIf="!useLinkButton"
        mat-raised-button
        color="primary"
        [disabled]="disabled"
        [ngClass]="buttonNgClass"
        [routerLink]="routerLink"
>
  <mat-icon class="valign-middle">{{isExisting ? 'edit' : 'add'}}</mat-icon>
  {{isExisting ? 'Edit' : 'New'}}
</button>
<a *ngIf="useLinkButton && !disabled" [ngClass]="ngClass" [routerLink]="routerLink">
  <mat-icon class="valign-middle">edit_document</mat-icon>
</a>
<button class="btn btn-link m-0 p-0" [disabled]="disabled" *ngIf="useLinkButton && disabled" [ngClass]="ngClass">
  <mat-icon class="valign-middle">edit_document</mat-icon>
</button>
